// 路由标识
export const ROUTER_BASE_URL = 'giftcard'

// 零售OSS地址
export const JD_ASSETS_URL = 'https://storage.360buyimg.com/order-web/credit-pay/'

// 京东云OSS地址
export const JDC_ASSETS_URL = 'https://jdpay.s3.cn-north-1.jdcloud-oss.com/pay-c-credit-pay-m/'

// 京东统一登录地址
export const JD_LOGIN_URL = 'https://plogin.m.jd.com/user/login.action?appid=2307&returnurl='

//
export const JD_SEARCH = 'https://s3-relay.360buyimg.com/relay/c/cut/6/ea5f4c3e1a513b83dbd776ed3af0e218'